import React from 'react';
import { createPortal } from 'react-dom';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

require('highcharts/modules/map')(Highcharts);

function MapChart(props) {


    const getRandomInt = (max) => {
        return Math.floor(Math.random() * max);
    }

    const getImageURL = (id) => {
        if (props?.dados) {
            const municipioImages = props.dados.filter(x => x.id == id && x?.imagem && x?.imagem.split('.').pop().toLowerCase() != 'mp4')
            console.log(id, municipioImages);

            if (municipioImages.length > 0) {
                // return '<video width="400" src="https://painel.tce.sp.gov.br/arquivos/questionario/media/85614-0-236493200.mp4" type="video/mp4" />'
                return 'https://painel.tce.sp.gov.br/arquivos/questionario/media/' + municipioImages[getRandomInt(municipioImages.length)].imagem
            }
            else { return null }
        }
    }

    const mapOptions = {

        tooltip: {
            shared: true,
            enabled: true,
            useHTML: true,
            backgroundColor: 'none',
            borderWidth: 0,
            shadow: false,
            // followPointer: true,
            headerFormat: '<div class="tooltipcss" id="tooltipdavitoria">',
            style: {
                // display:'flex',
                cursor: 'default',
                fontSize: '12px',
                whiteSpace: 'wrap',
                backgroundColor: "#ffffff" /* Palette.backgroundColor */,
                textAlign: 'center',
                opacity:'1',
                wordWrap: 'break-word',
                width: '200px',
                height: '400px'
            },
            pointFormatter: function () {
                console.log(this);
                if (this.id < 100) {
                    return this.name
                }
                const imgURL = getImageURL(this.id)
                if (imgURL)
                    return `<p>${this?.name}</p> 
                    <p>${this?.descricao}</p> 
                    
                    <img style=" width:100%; max-width: 250px; max-height: 250px;" src="${imgURL}"> 
                     `
                else {
                    return `${this.name}`
                }
            },
            footerFormat: '</div>',
        },
        title: {
            text: ''
        },
        credits: {
            enabled: false
        },
        mapNavigation: {
            enabled: true
        },
        chart: {
            animation: false
        },
        // plotOptions: {
        //map: { joinBy: ['hc-key', 'key', 'id'] },
        // series: {
        //     point: {
        //         events: {
        //             click: props?.onClick || null
        //         }
        //     }
        // }
        // },
        legend: {
            enabled: false
        },
        series: [{
            type: "map",
            // joinBy:  ['hc-key', 'key', 'id'],
            joinBy: ['id', 'id'],
            mapData: props?.desenhoMapa || [],
            data: props?.dados || [],
            name: props?.serieName || '',
            color: '#ff9999',
            point: {
                events: {
                    click: props?.clickMapa || null
                }
            },
            states: {
                hover: {
                    color: '#BADA55'
                }
            },

            dataLabels: {
                enabled: props?.showLabels || false,
                //format: '{point.name}',
                overflow: 'justify'
            },
            // tooltip: {
            //     useHTML: true,
            //     pointFormatter: function () {
            //         return 'sadasd<img src="https://www.highcharts.com/samples/graphics/sun.png">'
            //     },

            // pointFormat: '<b>{point.name}</b><br/><img src="https://painel.tce.sp.gov.br/arquivos/questionario/media/71076-0-585014171.jpg" />',
            //         '</span></span> {point.name}<br>' +
            //         '<span style="font-size:30px">{point.value}/km²</span>'

            // formatter: function () {
            //     return 'The value for abc';
            // },
            // formatter: function() {
            //     // var img = '<img src = "https://static.pexels.com/photos/6606/flowers-garden-orange-tulips.jpg" height="82" width="122"/>'
            //     console.log('foramtter'); 
            //     {createPortal(
            //         <p>This child is placed in the document body.</p>,
            //         document.body
            //       )}
            //   }

            // },
            // tooltip: {
            //     //outside: true,
            //     useHTML: true,
            //     enabled: true, //((opcoes && opcoes.tooltip != null) ? opcoes.tooltip : true),
            //     //pointFormat: tooltipIMG,
            //     tooltip: {
            //     backgroundColor: 'none',
            //     borderWidth: 0,
            //     shadow: false,
            //     useHTML: true,
            //     padding: 0,
            //     pointFormat: '<span class="f32"><span class="flag {point.properties.hc-key}">' +
            //         '</span></span> {point.name}<br>' +
            //         '<span style="font-size:30px">{point.value}/km²</span>',
            //     positioner: function () {
            //         return { x: 0, y: 250 };
            //     }
            // },
            //     formatter: function() {
            //         // const foto = retornarFoto(this.point.si, this.point.municipio);
            //         //console.log(foto);
            //         //if (foto){
            //             let img = `
            //                 <div style="max-width:250px;overflow: visible;overflow-wrap: break-word;">
            //                     <img style="height:250px;width:250px;" src="https://placedog.net/401`+''+`"/>
            //                     <br>
            //                     <div style="overflow:visible;">`+'foto[1]'+`</div>
            //                 </div>`
            //             return img
            //         }///
            //         // else
            //             // return false;
            //     // }
            //     /*
            //     positioner: function () {
            //         return { x: 0, y: 100 };
            //     }
            //     */
            // },
        }]
    };

    // series: [
    //     {
    //         name: 'FO-Brasil',
    //         mapData: brDados,
    //         //keys: ['id', 'value'],
    //         //joinBy: 'id',
    //         //data: dadosMapa,
    //         data: [],
    //          borderWidth: 0.5,
    //         states: {
    //             hover: {
    //                 color: '#a4edba'
    //             }
    //         }
    //     }],

    return (
        <div>

            <HighchartsReact
                containerProps={{ style: { height: "717px", "boxShadow": "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px" } }}
                highcharts={Highcharts}
                constructorType={'mapChart'}
                options={mapOptions}
            />
 
            
        </div>
    )
}

export default MapChart